// Radha — tenant settings writes (043). Currently just the receiving UPI VPA;
// the DB trigger is the authoritative gate (admin/cfo/finance_controller only).
import { useMutation } from "@tanstack/react-query";

import { supabase } from "../lib/supabase";

export function useSetTenantUpiVpa() {
  return useMutation({
    mutationFn: async (vpa: string) => {
      // RLS scopes SELECT/UPDATE to exactly the caller's own tenant row.
      const { data: own, error: readErr } = await supabase.from("tenants").select("id").single();
      if (readErr) throw readErr;
      const { error } = await supabase.from("tenants").update({ upi_vpa: vpa.trim() || null }).eq("id", own.id);
      if (error) throw error;
    },
  });
}

export function useSetEarlyPayDiscount() {
  return useMutation({
    mutationFn: async ({ pct, days }: { pct: number; days: number }) => {
      const { data: own, error: readErr } = await supabase.from("tenants").select("id").single();
      if (readErr) throw readErr;
      const { error } = await supabase
        .from("tenants")
        .update({ early_pay_discount_pct: pct, early_pay_discount_days: days })
        .eq("id", own.id);
      if (error) throw error;
    },
  });
}

export function useSetPoPortalThreshold() {
  return useMutation({
    mutationFn: async (threshold: number) => {
      const { data: own, error: readErr } = await supabase.from("tenants").select("id").single();
      if (readErr) throw readErr;
      const { error } = await supabase.from("tenants").update({ po_portal_auto_threshold: threshold }).eq("id", own.id);
      if (error) throw error;
    },
  });
}

export interface JurisdictionInput {
  country: string; base_currency: string; timezone: string; locale: string;
}

/** Jurisdiction (063). The four move together — country selects the conduct
 * rule, timezone drives the legal contact window, locale drives all money and
 * date formatting — so they are saved and audited as one change. */
export function useSetJurisdiction() {
  return useMutation({
    mutationFn: async (j: JurisdictionInput) => {
      const { data: own, error: readErr } = await supabase.from("tenants").select("id").single();
      if (readErr) throw readErr;
      const { error } = await supabase.from("tenants").update(j).eq("id", own.id);
      if (error) throw error;
    },
  });
}

export function useSetDirectPayThreshold() {
  return useMutation({
    mutationFn: async (threshold: number) => {
      const { data: own, error: readErr } = await supabase.from("tenants").select("id").single();
      if (readErr) throw readErr;
      const { error } = await supabase.from("tenants").update({ direct_pay_max_threshold: threshold }).eq("id", own.id);
      if (error) throw error;
    },
  });
}
